import './polyfills';

import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router';
import { config } from './config';
import { handleLoginRedirect, main, store } from './configuration';
import { createUserManager } from './configuration/login/login';
import { attemptInitialSignIn } from './configuration/setup/oauth';
import App from './features/app/components/App';
import { ErrorBoundary } from './features/app/components/ErrorBoundary';

function renderApplication() {
    const container = document.getElementById('root');
    const root = createRoot(container!);

    root.render(
        <ErrorBoundary>
            <Provider store={store}>
                <BrowserRouter>
                    <App />
                </BrowserRouter>
            </Provider>
        </ErrorBoundary>,
    );
}

const userManager = main(createUserManager());
const attemptSignInAndRenderApplication = () => {
    return attemptInitialSignIn(userManager)
        .then(() => renderApplication())
        .catch((error: any) => {
            console.error('could not start application', error);
        });
};

if (window.location.href.startsWith(config.login.redirectUri as string)) {
    handleLoginRedirect(userManager).then(() => attemptSignInAndRenderApplication());
} else if (import.meta.env.PROD) {
    attemptSignInAndRenderApplication();
} else if (import.meta.env.DEV) {
    import('../mocks/serviceMock')
        .then(({ startWorker }) => startWorker())
        .then(() => attemptSignInAndRenderApplication());
}
